module.exports = __webpack_public_path__ + "static/media/Cape Verde.a0a46a14.png";